import { render } from "./TvmMultiSelectSuggestions.vue?vue&type=template&id=2e5584a8&scoped=true"
import script from "./TvmMultiSelectSuggestions.js?vue&type=script&lang=js&external"
export * from "./TvmMultiSelectSuggestions.js?vue&type=script&lang=js&external"

import "./TvmMultiSelectSuggestions.vue?vue&type=style&index=0&id=2e5584a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5584a8"]])

export default __exports__